import { Injectable, Signal, inject } from '@angular/core';
import StorageLimit, { StorageLimitDeleteResult } from 'mbs-ui-shared@models/StorageLimit';
import { StorageLimitsService } from 'mbs-ui-shared@services/storage-limits.service';
import { StorageLimitsStore } from 'mbs-ui-shared@store/storageLimits/storageLimits.store';
import { Observable, of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StorageLimitsFacade {
  private store = inject(StorageLimitsStore);
  private service = inject(StorageLimitsService);

  public readonly limits: Signal<StorageLimit[]> = this.store.all;
  public readonly loading: Signal<boolean> = this.store.loading;
  public readonly loaded: Signal<boolean> = this.store.loaded;

  public getLimits(): Observable<StorageLimit[]> {
    if (this.loaded()) return of(this.limits());

    this.store.setLoading(true);

    return this.service.getLimits().pipe(
      tap((limits) => this.store.setAll(limits)),
      finalize(() => this.store.setLoading(false))
    );
  }

  public setLimit(newLimit: Partial<StorageLimit>): Observable<void> {
    return this.service.setLimit(newLimit).pipe(tap(() => this.invalidate()));
  }

  public updateLimit(newLimit: Partial<StorageLimit>): Observable<void> {
    return this.service.updateLimit(newLimit).pipe(tap(() => this.invalidate()));
  }

  public deleteLimit(id: number, newPlanId?: number): Observable<StorageLimitDeleteResult> {
    return this.service.deleteLimit(id, newPlanId).pipe(tap(() => this.invalidate()));
  }

  public invalidate(): void {
    this.store.invalidate();
  }
}
